// extracted by mini-css-extract-plugin
module.exports = {"regionalAnalysisContainer":"SubregionForecastPage_regionalAnalysisContainer__r_wLU"};